import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./MyStyles.css";

function Menu(){

const userGroup = localStorage.getItem("userGroup");

const MenuCard = ({link,title,icon,color,external}) => (

<div className="col-xl-2 col-lg-3 col-md-4 col-sm-6 mb-4">

{external ? (

<a href={link} target="_blank" rel="noreferrer" className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</a>

) : (

<Link to={link} className="menu-link">

<div className="menu-card" style={{borderTop:`4px solid ${color}`}}>

<div className="menu-icon" style={{color:color}}>
<FontAwesomeIcon icon={icon} size="2x"/>
</div>

<p className="menu-title">{title}</p>

</div>

</Link>

)}

</div>

);

return(

<section className="menu-section container-fluid mt-4">

<div className="row">

{/* Dashboard */}
{userGroup === 'Admin' && (
<MenuCard link="/" title="Dashboard" icon="fa-solid fa-chart-line" color="#0d6efd"/>
)}


{/* Pharmacy */}
{userGroup === 'Admin' || userGroup === 'Pharmacy' ? (
<MenuCard link="/pharm-menu/" title="Pharmacy" icon="fa-solid fa-prescription" color="#20c997"/>
) : null}

{/* Pharmacy Store */}
{userGroup === 'Admin' || userGroup === 'PharmacyStore' ? (
<MenuCard link="/pharm-store/" title="Pharmacy - Store" icon="fa-solid fa-prescription-bottle-medical" color="#6610f2"/>
) : null}


{/* Messaging / Tools */}
{userGroup === 'Admin' || userGroup === 'Pharmacy' || userGroup === 'PharmacyStore' ? (
<>
<MenuCard link="/comp-mess/" title="Messaging" icon="fa fa-comment-sms" color="#0d6efd"/>

<MenuCard link="/speech" title="Speech-Text" icon="fa fa-microphone" color="#d63384"/>

<MenuCard link="/events" title="Events List" icon="fa-regular fa-calendar-days" color="#20c997"/>

<MenuCard link="/todolist" title="ToDo Lists" icon="fa-solid fa-tasks" color="#fd7e14"/>

<MenuCard link="/master-menu/" title="Masters Setting" icon="fa fa-gears" color="#fd7e14"/>
<MenuCard link="/support/" title="MGM Support" icon="fa fa-wrench" color="#dc3545"/>
</>
) : null}

{/* News */}
{userGroup === 'Admin' ? (
<MenuCard link="/news/" title="News & Events" icon="fa-regular fa-newspaper" color="#fd7e14"/>
) : null}

{/* Barcode */}
{userGroup === 'Admin' || userGroup === 'FrontOffice' ? (
<MenuCard link="/barcode/" title="Generate Barcode" icon="fa fa-barcode" color="#20c997"/>
) : null}

</div>

</section>

)

}

export default Menu;